export const FETCH_IMPORT_HISTORY_SUCCESS = 'FETCH_IMPORT_HISTORY_SUCCESS';
export const FETCH_IMPORT_HISTORY_STATUS_SUCCESS = 'FETCH_IMPORT_HISTORY_STATUS_SUCCESS';
export const FETCHING_IMPORT_HISTORY_SUCCESS = 'FETCHING_IMPORT_HISTORY_SUCCESS';



// WEBPACK FOOTER //
// ./src/redux/importHistory/ImportHistoryConstants.js